(function () {
  'use strict';

  angular.module('app').component('discountCouponDetail', discountCouponDetail());

  function discountCouponDetail() {
    return {
      bindings: {},
      controller: DiscountCouponDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/discount-coupons/discount-coupon-detail/discount-coupon-detail.component.html',
    };
  }

  DiscountCouponDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'AbilityService',
    '$location',
    '$routeParams',
    'DiscountCouponService',
    'PriceListService',
    'TourService',
    'TransportationService',
    'HotelService',
    'PackageService',
  ];

  function DiscountCouponDetailComponent(
    config,
    UtilService,
    moment,
    AbilityService,
    $location,
    $routeParams,
    DiscountCouponService,
    PriceListService,
    TourService,
    TransportationService,
    HotelService,
    PackageService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canUpdate: AbilityService.can('update_discountcoupon_accountadmin'),
      canDestroy: AbilityService.can('destroy_discountcoupon_accountadmin'),
    };

    vm.discountTypes = config.COMPUTATION_TYPES;
    vm.dateDisplay = config.DATE_DISPLAY;

    vm.products = [];
    vm.allProductsChecked = [];
    vm.searchProductsBy = [];

    // private properties
    // -----------------------
    let itemId = $routeParams.id;
    const dateFormatDB = config.DATE_FORMAT_DB;

    vm.$onInit = function () {
      if (itemId) {
        // View / Edit
        getDiscountCoupon();
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          from: '',
          to: '',
          all_tours: true,
          all_transportation: true,
          all_hotels: true,
          all_packages: true,
        };

        setDatePickerOptions();

        getPriceLists();
      }
    };

    // public methods
    // -----------------------
    vm.selectDiscountType = function () {
      vm.item.value = null;
      vm.item.price_list_id = null;
    };

    vm.selectPriceList = function (price_list) {
      if (vm.item.price_list && vm.item.price_list.id === price_list.id) return;

      vm.item.price_list = price_list;
    };

    vm.editDiscountCoupon = function () {
      vm.editMode = true;
      vm.viewMode = false;

      getPriceLists();
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.enableAllTours = function () {
      if (!vm.item.all_tours) {
        getTours();
      }
    };

    vm.enableAllTransportation = function () {
      if (!vm.item.all_transportation) {
        getTransportations();
      }
    };

    vm.enableAllHotels = function () {
      if (!vm.item.all_hotels) {
        getHotels();
      }
    };

    vm.enableAllPackages = function () {
      if (!vm.item.all_packages) {
        getPackages();
      }
    };

    // Create/Update
    vm.saveDiscountCoupon = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        // vm.UtilService.scrollToTop();

        return;
      }

      vm.item.discount_coupon_products = setCheckedProducts();

      vm.item.from = moment(vm.item.from).format(dateFormatDB); // 2021-01-28
      vm.item.to = moment(vm.item.to).format(dateFormatDB); // 2021-01-28

      // TODO: willy - check utc
      // vm.item.from = vm.UtilService.startOfDayFormat(vm.item.from);
      // vm.item.to   = vm.UtilService.endOfDayFormat(vm.item.to);

      // console.log(vm.item);
      // return;

      vm.sendingForm = true;
      DiscountCouponService.saveDiscountCoupon(vm.item).then(function (data) {
        if (!data.errors) {
          if (!vm.editMode) {
            // create
            // or going to list ????
            $location.path(`/discount_coupons/${data.id}`);
            return;
          }

          vm.item = data;
          setItemOptions(data);

          if (!vm.item.all_tours) {
            setDiscountCouponProductsUpdate('tour');
          }

          if (!vm.item.all_transportation) {
            setDiscountCouponProductsUpdate('transportation');
          }

          if (!vm.item.all_hotels) {
            setDiscountCouponProductsUpdate('hotel');
          }

          if (!vm.item.all_packages) {
            setDiscountCouponProductsUpdate('package');
          }

          // vm.UtilService.scrollToTop();
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(data.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.cancel = function () {
      // vm.onDiscountCouponCanceled();
      $location.path('/discount_coupons');
    };

    // private methods
    // -----------------------
    function getDiscountCoupon() {
      vm.loadingItem = true;
      DiscountCouponService.getDiscountCoupon(itemId).then(function (data) {
        vm.item = data;

        setItemOptions(vm.item, $routeParams.mode);

        setDatePickerOptions();

        vm.loadingItem = false;
      });
    }

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editDiscountCoupon();
      }

      item.from = moment(item.from);
      item.to = moment(item.to);

      if (!item.all_tours) {
        getTours();
      }

      if (!item.all_transportation) {
        getTransportations();
      }

      if (!item.all_hotels) {
        getHotels();
      }

      if (!item.all_packages) {
        getPackages();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function setDatePickerOptions() {
      vm.fromDateOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function applyDateRangePicker() {
            vm.toDateOptions.minDate = angular.copy(vm.item.from).add(1, 'days');

            // Increase end date value if below or equal
            if (vm.item.to && vm.item.to <= vm.item.from) {
              vm.item.to = vm.toDateOptions.minDate;
            }

            setTimeout(() => {
              // hack
              document.querySelector('input[name="end_date"]').focus();
              // document.querySelector<HTMLElement>('input[name="to"]').click();
            }, 100);
          },
        },
      };

      if (vm.createMode) {
        vm.fromDateOptions.minDate = moment();
      }

      vm.toDateOptions = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: vm.item.from,
        locale: {
          format: vm.dateDisplay,
        },
      };
    }

    function getPriceLists() {
      if (vm.priceLists) return;

      let params = {
        get: 'active',
        skip_check_role: true,
      };

      vm.loadingPriceLists = true;
      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;

        vm.loadingPriceLists = false;
      });
    }

    // tours
    function getTours() {
      if (vm.toursData) return;

      let params = {
        get: 'selector',
        skip_check_role: true,
      };

      vm.loadingTours = true;
      TourService.getTours(params).then(function (data) {
        vm.toursData = data.items;
        vm.products['tour'] = vm.toursData;

        setDiscountCouponProducts('tour');

        vm.loadingTours = false;
      });
    }

    // transportation
    function getTransportations() {
      if (vm.transportationData) return;

      let params = {
        get: 'selector',
        skip_check_role: true,
      };

      vm.loadingTransportation = true;
      TransportationService.getTransportations(params).then(function (data) {
        vm.transportationData = data.items;
        vm.products['transportation'] = vm.transportationData;

        setDiscountCouponProducts('transportation');

        vm.loadingTransportation = false;
      });
    }

    // hotels
    function getHotels() {
      if (vm.hotelsData) return;

      let params = {
        get: 'selector',
        skip_check_role: true,
      };

      vm.loadingHotels = true;
      HotelService.getHotels(params).then(function (data) {
        vm.hotelsData = data.items;
        vm.products['hotel'] = vm.hotelsData;

        setDiscountCouponProducts('hotel');

        vm.loadingHotels = false;
      });
    }

    // packages
    function getPackages() {
      if (vm.packagesData) return;

      let params = {
        get: 'selector',
        skip_check_role: true,
      };

      vm.loadingPackages = true;
      PackageService.getPackages(params).then(function (data) {
        vm.packagesData = data.items;
        vm.products['package'] = vm.packagesData;

        setDiscountCouponProducts('package');

        vm.loadingPackages = false;
      });
    }

    function setDiscountCouponProducts(productType) {
      let discountCouponProducts = null;
      if (!vm.createMode) {
        discountCouponProducts = vm.item.discount_coupon_products.filter(
          (product) => product.product_type === productType
        );
      }

      vm.products[productType].forEach((product) => {
        product.product_type = productType;
        product.product_id = product.id;
        product.checked = false;

        if (!vm.createMode && discountCouponProducts.length > 0) {
          let discountCouponProduct = discountCouponProducts.find(
            (discountCouponProduct) => discountCouponProduct.product_id === product.id
          );

          if (discountCouponProduct) {
            product.discount_coupon_product_id = discountCouponProduct.id;
            product.checked = true;
          }
        }
      });

      if (!vm.createMode) {
        vm.allProductsChecked[productType] = vm.products[productType].some(
          (product) => !product.checked
        )
          ? false
          : true;
      }
    }

    function setDiscountCouponProductsUpdate(productType) {
      let discountCouponProducts = vm.item.discount_coupon_products.filter(
        (product) => product.product_type === productType
      );

      vm.products[productType].forEach((product) => {
        if (!product.checked && product.discount_coupon_product_id) {
          delete product.discount_coupon_product_id;
        }

        if (product.checked && !product.discount_coupon_product_id) {
          let discountCouponProduct = discountCouponProducts.find(
            (discountCouponProduct) => discountCouponProduct.product_id === product.id
          );

          product.discount_coupon_product_id = discountCouponProduct.id;
        }
      });

      if (vm.searchProductsBy[productType]) {
        vm.searchProductsBy[productType] = '';

        let productsData;
        switch (productType) {
          case 'tour':
            productsData = vm.toursData;
            break;
          case 'transportation':
            productsData = vm.transportationData;
            break;
          case 'hotel':
            productsData = vm.hotelsData;
            break;
          case 'package':
            productsData = vm.packagesData;
            break;
        }

        vm.products[productType] = productsData;
      }
    }

    // Set and format discount_coupon_products
    function setCheckedProducts() {
      let checkedProducts = [];

      if (vm.products['tour']) {
        checkedProducts = checkedProducts.concat(
          vm.products['tour'].filter((product) => product.checked)
        );
      }

      if (vm.products['transportation']) {
        checkedProducts = checkedProducts.concat(
          vm.products['transportation'].filter((product) => product.checked)
        );
      }

      if (vm.products['hotel']) {
        checkedProducts = checkedProducts.concat(
          vm.products['hotel'].filter((product) => product.checked)
        );
      }

      if (vm.products['package']) {
        checkedProducts = checkedProducts.concat(
          vm.products['package'].filter((product) => product.checked)
        );
      }

      return checkedProducts.map((checkedProduct) => {
        let discountCouponProduct = {
          product_type: checkedProduct.product_type,
          product_id: checkedProduct.product_id,
          id: null,
        };

        if (checkedProduct.discount_coupon_product_id) {
          discountCouponProduct.id = checkedProduct.discount_coupon_product_id;
        }

        return discountCouponProduct;
      });
    }
  }
})();
